import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import { SettingService } from 'projects/Administration/src/app/business-services/setting.service';
import { VehicleBusinessService } from 'projects/Administration/src/app/business-services/vehicle-service';
import { CultureLocaleService } from 'projects/Administration/src/app/services/culture-locale.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import * as Enums from "projects/Autofacets-Core/src/app/utils/enums";
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { FeatureCode, ModuleNames } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { CityModel, CustomerDetailsViewModel, CustomerModel, DuplicateCustomerRequestModel } from '../../../../business-entities/customer-view.model';
import { CustomerService } from '../../../../business-services/customer.service';
import { PaymentMasterService } from '../../../../business-services/payment-master.service';
import { MultiCustomerListComponent } from './multi-customer-list/multi-customer-list.component';
import {CustomerPrivacyLogModel} from '../../../../business-entities/customer-privacy-log-model';
import { ViewCustomerComponent } from '../view-customer.component';
import { DealerBusinessService } from 'projects/Administration/src/app/business-services/dealer.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { CountryISO } from 'ngx-intl-tel-input-gg';
@Component({
  selector: 'app-customer-details',
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.css']
})
export class CustomerDetailsComponent implements OnInit {
  @Output() showVehileAndOtherDetailsTabs = new EventEmitter<any>();
  @Input() customerDetailsFromWidget: any;
  @Input() isFromServiceAdvisor: boolean;
  @Input() fromVehicleScreen: boolean;
  @Input() fromVehicleCustomerDetails:boolean = false;
  @Input() preferredDealerId: string = "";
  customerForm: FormGroup;
  customergroupName: string;
  salutationName: string;
  dateOfBirth: string;
  registrationDate: string;
  postcodeName: string;
  cityName: string;
  countryName: string;
  countryId: number;
  contactUniqueId: string;
  customerDetail: CustomerDetailsViewModel;
  customerId: number = 0;
  companyShow: boolean = false;
  accountShow: boolean = false;
  userMobileCode: string;
  userMobileCountryCode: string;
  customerGroupList: any;
  addressSalutationList: any;
  paymentMethodList: any;
  paymentTermsList: any;
  reminderTermsList: any;
  laborAndItemSalesPriceList:any;
  paymentMethodCode: string;
  paymentTermsCode: string;
  reminderTermsCode: string;
  laborPriceGroup: string;
  itemSalesPriceGroup: string;
  isVatApplyOnDemandDefault : boolean = true;
  postCodeList: any;
  postCodeRawData: any;
  cityList: CityModel[];
  countryList: any;
  responseResult: any;
  saveVehicleDetails: boolean = false;
  features: Features[] = [];
  endDate: string;
  userPhoneNumberCode: string;
  isFormValid: boolean = false;
  popupCloseResult = false;
  search: string;
  customerList: CustomerDetailsViewModel[];
  totalCount: number = 0;
  advanceSearchRequest: any = {
    birthDate: '',
    customerName: '',
    postCode: null,
    mobile: ''
  }
  isAdvanceSearch: boolean;
  ispostcodeRequired: boolean;
  iscountryRequired: boolean;
  iscityRequired: boolean;
  iscustomergroupRequired: boolean;
  isCompanynameRequired: boolean;
  allowCompanyCreation: boolean;
  allowAccount: boolean;
  allowQuickSearch: boolean;
  IsDMS: boolean;
  validstring: any;
  accountName: any;
  filterAccountList: [] = [];
  accountSearch: string;
  accountCompanyName: any;
  accountCompanyId:any;
  isShowAccountCompanyName:boolean = true;
  customerLogDetails:CustomerPrivacyLogModel[];
  dealerList: any;
  dealerSelected: string = '';
  dealerId: string = null;
  subscription : Subscription;
  paymentMethodDefault:string = '';
  paymentTermDefault:string = '';
  reminderTermDefault:string = '';
  laborGroupPriceDefault:any='';
  itemSalesGroupPriceDefault : any = '';
  customerGroupDefault:string = '';
  isCountryChanged:boolean = null;
  hidePaymentDetails:boolean = false;
  hideExtraInformation:boolean = false;
  _clientName:string;
  isBNH: boolean = false;
  isCrmNewVehicle:boolean;
  existingMobileNo:string;
  CountryISO = CountryISO;
  isInitialLoad: boolean= true;
  isInitialLoadLandline: boolean= true;
  onlyCountries: string[] = [];
  countryDialCodes: any[]= [];
  selectedCountryISOMobile= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  selectedCountryISOLandline= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  duplicateCustomerList:any;
  @ViewChild('customerDuplication') customerDuplication: ElementRef;

  constructor(private readonly service: CustomerService,
    private readonly vehicleservice: VehicleBusinessService,
    private readonly spinner: NgxSpinnerService,
    private readonly toaster: ToastrService,
    private readonly translate: TranslateService,
    private readonly formBuilder: FormBuilder,
    private readonly activeModal: NgbActiveModal,
    private readonly cultureLocaleService: CultureLocaleService,
    private readonly modalService: NgbModal,
    private readonly secureStorage: SecureStorage,
    private readonly cdr: ChangeDetectorRef,
    public datepipe: DatePipe,
    private readonly settingService: SettingService,
    private readonly paymentService: PaymentMasterService,
    private readonly dealerService: DealerBusinessService,
    private readonly currentLanguageService: CurrentLanguage,
  ) {

  }

  async ngOnInit() {
    this.onlyCountries = this.settingService.onlyCountries;
    this.countryDialCodes = this.settingService.countryDialCodes;
    this._clientName = localStorage.getItem("Theme");
    this.hidePaymentDetails = this.hideExtraInformation = localStorage.getItem("Theme") === 'mg';
    if (this._clientName === 'mg' && this.service.crmVehicleObj) {
      this.isCrmNewVehicle = this.service.crmVehicleObj?.id <= 0;
    }
    if(this._clientName === 'bnh'){
      this.isBNH = true;
    }
    this.customerId = this.service.customerId;
    this.getvalidateConfig();
    this.customerForm = this.formBuilder.group({
      customerNo: [''],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      custName: ['', [Validators.required]],
      customergroup: [this.customerGroupDefault, [Validators.required]],
      salutation: [''],
      personNumber: [''],
      registrationNumber: [''],
      dateOfBirth: [''],
      registrationDate: [''],
      address1: ['', [Validators.required]],
      address2: [''],
      postcode: ['', [Validators.required]],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      email: ['', [Validators.pattern(Enums.RegexKeyCollection.CustomerEmail)]],
      email2: ['', [Validators.pattern(Enums.RegexKeyCollection.CustomerEmail)]],
      mobile: ['', [Validators.required]],
      landline: [''],
      fax: ['', [Validators.pattern(/^\d{8,10}$/)]],
      isActive: [true],
      isRegularEmail: [false],
      isEmail: [false],
      isFax: [false],
      isSms: [false],
      isPhone: [false],
      IsMarketingConsent:[false],
      contactID: [''],
      customerDisagreement:[false],
      paymentMethodCode: [this.paymentMethodDefault],
      paymentTermsCode: [this.paymentTermDefault],
      reminderTermsCode: [this.reminderTermDefault],
      laborPriceGroup:[this.laborGroupPriceDefault],
      itemSalesPriceGroup:[this.itemSalesGroupPriceDefault],
      gender: ['0'],
      dealerId:[''],
      remark: [''],
      isMinBilUser: [false],
      navisionId: [''],
      cbid: ['']
    });
    this.customerForm.get('customerNo').disable(); 
    this.customerForm.controls['laborPriceGroup'].disable();
    this.customerForm.controls['itemSalesPriceGroup'].disable();
    this.customerForm.controls.custName.disable();
    this.customerForm.controls.registrationNumber.disable();
    this.customerForm.controls.registrationDate.disable();
    this.endDate = Utility.GetFormattedDate(new Date());
    await this.LoadAllDetails();
  }

  async LoadAllDetails(){
    this.getCustomerGroup();
    this.spinner.show();
    this.getAddressSalutationDropdown();
    this.getPostCodeDropdown();
    this.getFeatures();
    
    if (!this.hidePaymentDetails) {
      this.getPaymentMethod();
      this.getPaymentTerms();
      this.getReminderTerms();
      this.getLaborandItemSalesPriceGroup();
    }
    
    if (!this.hideExtraInformation) {
      await this.GetDealerList();
    }
    //Important Note:- this method countryDropdownDetails should be called after all dropdown method call for load customer and dropdown details.
    this.countryDropdownDetails();
    this.spinner.hide();
  }

  async GetDealerList() {
    await this.dealerService.getDealerBrandList().then(res => {
      if (res) {
        if (res.dealerList) {
          this.dealerList = this.mapdealer(res.dealerList);
          if(!this.empty(this.preferredDealerId))
          {
            this.customerForm.patchValue({
            dealerId: this.preferredDealerId
          })
        }
        }
      }
    })
  }
  mapdealer(array: any) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element=>{
        let single = Object();
        single.dealerId = element.dealerId
        single.dealerName = element.dealerName
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  async getFeatures() {
    this.features = this.secureStorage.getKeyData('feature');
    if(this.features == null || this.features == undefined){
      this.subscription = this.currentLanguageService.featureList.subscribe((res)=>{
        this.features = res;
        if (this.features?.length > 0) {
          this.allowCompanyCreation = this.features.find(x => x.featureCode === FeatureCode.AllowCompanyCreation)?.isActive;
          this.allowAccount = this.features.find(x => x.featureCode === FeatureCode.AllowAccount)?.isActive;
          this.allowQuickSearch = this.features.find(x => x.featureCode === FeatureCode.AllowQuicksearch)?.isActive;
          this.IsDMS = this.features.find(x => x.featureCode === FeatureCode.DMS)?.isActive;
        }
      })
    }else{
      this.allowCompanyCreation = this.features.find(x => x.featureCode === FeatureCode.AllowCompanyCreation)?.isActive;
      this.allowAccount = this.features.find(x => x.featureCode === FeatureCode.AllowAccount)?.isActive;
      this.allowQuickSearch = this.features.find(x => x.featureCode === FeatureCode.AllowQuicksearch)?.isActive;
      this.IsDMS = this.features.find(x => x.featureCode === FeatureCode.DMS)?.isActive;
    }
  }

  async getvalidateConfig() {
    this.settingService.getFieldConfiguration("Customer").then((res) => {
      if (res.responseObject) {
        this.validstring = res.responseObject;
        if (!isNullOrUndefined(this.validstring)) {
          let postvalid = this.validstring.find(x => x.columnName == "postcode")
          if (!isNullOrUndefined(postvalid)) {
            this.ispostcodeRequired = postvalid.isRequired;
          }
          let cityvalid = this.validstring.find(x => x.columnName == "city")
          if (!isNullOrUndefined(cityvalid)) {
            this.iscityRequired = cityvalid.isRequired;
          }
          let countryvalid = this.validstring.find(x => x.columnName == "country")
          if (!isNullOrUndefined(countryvalid)) {
            this.iscountryRequired = countryvalid.isRequired;
          }
          let customergroupvalid = this.validstring.find(x => x.columnName == "customergroup")
          if (!isNullOrUndefined(customergroupvalid)) {
            this.iscustomergroupRequired = customergroupvalid.isRequired;
          }
          let companyNamevalid = this.validstring.find(x => x.columnName == "company")
          if (!isNullOrUndefined(companyNamevalid)) {
            this.isCompanynameRequired = companyNamevalid.isRequired;
          }
        }
        this.customerForm = this.formBuilder.group({
          customerNo: [''],
          firstName: ['', [Validators.required]],
          lastName: ['', [Validators.required]],
          custName: ['', [Validators.required]],
          customergroup: [this.customerGroupDefault, this.iscustomergroupRequired ? [Validators.required] : null],
          salutation: [''],
          personNumber: [''],
          registrationNumber: [''],
          dateOfBirth: [''],
          registrationDate: [''],
          address1: ['', [Validators.required]],
          address2: [''],
          postcode: ['', (this.ispostcodeRequired ? [Validators.required] : null)],
          city: ['', this.iscityRequired ? [Validators.required] : null],
          country: ['', this.iscountryRequired ? [Validators.required] : null],
          email: ['', [Validators.pattern(Enums.RegexKeyCollection.CustomerEmail)]],
          email2: ['', [Validators.pattern(Enums.RegexKeyCollection.CustomerEmail)]],
          mobile: ['', [Validators.required]],
          landline: [''],
          fax: ['', [Validators.pattern(/^\d{8,10}$/)]],
          isActive: [true],
          isRegularEmail: [false],
          isEmail: [false],
          isFax: [false],
          isSms: [false],
          isPhone: [false],
          isAccountHolderCompany: [],
          accountCompanyName: [''],
          IsMarketingConsent:[false],
          contactID: [''],
          customerDisagreement:[false],
          paymentMethodCode: [this.paymentMethodDefault],
          paymentTermsCode: [this.paymentTermDefault],
          reminderTermsCode: [this.reminderTermDefault],
          laborPriceGroup:[this.laborGroupPriceDefault],
          itemSalesPriceGroup:[this.itemSalesGroupPriceDefault],
          gender:['0'],
          dealerId:[''],
          remark: [''],
          isMinBilUser: [false],
          navisionId: [''],
          cbid: ['']
        });

      }
      else{
        this.customerForm = this.formBuilder.group({
          customerNo: [''],
          firstName: ['', [Validators.required]],
          lastName: ['', [Validators.required]],
          custName: ['', [Validators.required]],
          customergroup: [this.customerGroupDefault, [Validators.required]],
          salutation: [''],
          personNumber: [''],
          registrationNumber: [''],
          dateOfBirth: [''],
          registrationDate: [''],
          address1: ['', [Validators.required]],
          address2: [''],
          postcode: ['',  [Validators.required]],
          city: ['', [Validators.required]],
          country: ['',[Validators.required]],
          email: ['', [Validators.pattern(Enums.RegexKeyCollection.CustomerEmail)]],
          email2: ['', [Validators.pattern(Enums.RegexKeyCollection.CustomerEmail)]],
          mobile: ['', [Validators.required]],
          landline: [''],
          fax: ['', [Validators.pattern(/^\d{8,10}$/)]],
          isActive: [true],
          isRegularEmail: [false],
          isEmail: [false],
          isFax: [false],
          isSms: [false],
          isPhone: [false],
          isAccountHolderCompany: [],
          accountCompanyName: [''],
          IsMarketingConsent:[false],
          contactID: [''],
          customerDisagreement:[false],
          paymentMethodCode: [this.paymentMethodDefault],
          paymentTermsCode: [this.paymentTermDefault],
          reminderTermsCode: [this.reminderTermDefault],
          laborPriceGroup :[this.laborGroupPriceDefault],
          itemSalesPriceGroup:[this.itemSalesGroupPriceDefault],
          gender:['0'],
          dealerId:[''],
          remark: [''],
          isMinBilUser: [false],
          navisionId: [''],
          cbid: ['']
        });
      }
      this.customerForm.get('customerNo').disable();
      this.customerForm.controls['laborPriceGroup'].disable();
      this.customerForm.controls['itemSalesPriceGroup'].disable();
      this.customerForm.controls.custName.disable();
      this.customerForm.controls.registrationNumber.disable();
      this.customerForm.controls.registrationDate.disable();
      this.endDate = Utility.GetFormattedDate(new Date());
      this.loadCallerFormData();
    });
  }
  loadCallerFormData(){
    if (this.service.customerFromCaller) {
      this.companyShow = this.service.customerFromCaller.customerTypeId == 2;
      this.PatchDataFound(this.service.customerFromCaller);
      if (this.companyShow) {
        let element = <HTMLInputElement>document.getElementById("customCheck1");
        if(element) {
          element.click();
        }
      }
      this.enableDisableControls();
    }
  }
  selectEvent(item) {
    this.accountCompanyId=item;
    this.filterAccountList = [];
  }

  async getAccountName(valu:any) {
    await this.service.getAccountsAutoComplete(valu).then((response) => {
      this.filterAccountList = response.responseObject;
      this.accountCompanyId=response.responseObject[0].accountNo;
      this.accountCompanyName=response.responseObject[0].accountName;
    });
  }
  checkMarketingConsentValue(e:any){
    this.customerForm.patchValue({
      isRegularEmail: e.target.checked,
      isEmail: e.target.checked,
      isSms: e.target.checked,
      isPhone :e.target.checked
    })
    if(!e.target.checked)
    {
      this.customerForm.get('isRegularEmail').disable()
      this.customerForm.get('isEmail').disable()
      this.customerForm.get('isSms').disable()
      this.customerForm.get('isPhone').disable()
    }
    else{
      this.customerForm.get('isRegularEmail').enable()
      this.customerForm.get('isEmail').enable()
      this.customerForm.get('isSms').enable()
      this.customerForm.get('isPhone').enable()
    }
  }
  checkMarketingValue(_e:any){
    let isRegularEmail = this.customerForm.get('isRegularEmail').value;
    let isSms =  this.customerForm.get('isSms').value;
    let isPhone = this.customerForm.get('isPhone').value;
    let isEmail = this.customerForm.get('isEmail').value;
    if(!isRegularEmail && !isSms && !isPhone && !isEmail)
    {
      this.customerForm.patchValue({
        IsMarketingConsent: false
      })
    }
    if(isRegularEmail || isSms || isPhone || isEmail)
    {
      this.customerForm.patchValue({
        IsMarketingConsent: true
      })
    }
  }

  accountValueChange(event: any) {
    if (event.length > 3) {
      this.service.getAccountsAutoComplete(event).then((response) => {
        this.filterAccountList = response.responseObject;
      });
    }
  }

  async getCustomerGroup() {
    await this.service.GetCustomerGroupDropdown().then((response) => {
      this.customerGroupList = response.responseObject.filter(x => x.isDisplay);
      this.customerGroupList = this.customerGroupList.sort((a, b) => {
        const codeA = String(a?.code || '').trim();
        const codeB = String(b?.code || '').trim();
        const isNumericA = /^\d+$/.test(codeA);
        const isNumericB = /^\d+$/.test(codeB);

        if (isNumericA !== isNumericB) {
          return isNumericA ? 1 : -1;
        }

        return codeA.localeCompare(codeB, undefined, { numeric: true, sensitivity: 'base' });
      });
      this.selectDefaultCustomerGroup();
    });
  }

  selectDefaultCustomerGroup(){
    if(this.customerGroupList != null && this.customerGroupList.length > 0){
      let personalDefaultValue = this.customerGroupList.filter(x=>x.isDefaultPersonal);
      let companyDefaultValue = this.customerGroupList.filter(x=>x.isDefaultCompany);
      if(personalDefaultValue.length > 0 && companyDefaultValue.length > 0){
        this.customerGroupDefault = this.companyShow? companyDefaultValue[0].code : personalDefaultValue[0].code;
        this.customerForm.patchValue({
          customergroup:this.customerGroupDefault
        })
      }
    }
  }
  async getPaymentMethod() {
    await this.paymentService.GetPaymentMethodDropdown().then((response) => {
      this.paymentMethodList = response.responseObject;
      if(this.paymentMethodList != null && this.paymentMethodList.length > 0){
        let defaultValue = this.paymentMethodList.filter(x=>x.isDefault);
        if(defaultValue.length > 0){
          this.paymentMethodDefault = defaultValue[0].paymentCode;
          this.customerForm.patchValue({
            paymentMethodCode:this.paymentMethodDefault
          })
        }
      }
    });
  }
  async getPaymentTerms() {
    await this.paymentService.GetPaymentTermDropdown().then((response) => {
      this.paymentTermsList = response.responseObject;
      if(this.paymentTermsList != null && this.paymentTermsList.length > 0){
        let defaultValue = this.paymentTermsList.filter(x=>x.isDefault);
        if(defaultValue.length > 0){
          this.paymentTermDefault = defaultValue[0].paymentTermCode;
          this.customerForm.patchValue({
            paymentTermsCode:this.paymentTermDefault
          })
        }
      }
    });
  }
  async getReminderTerms() {
    await this.paymentService.GetReminderTermDropdown().then((response) => {
      this.reminderTermsList = response.responseObject;
      if(this.reminderTermsList != null && this.reminderTermsList.length > 0){
        let defaultValue = this.reminderTermsList.filter(x=>x.isDefault);
        if(defaultValue.length > 0){
          this.reminderTermDefault = defaultValue[0].reminderTermCode;
          this.customerForm.patchValue({
            reminderTermsCode:this.reminderTermDefault
          })
        }
      }
    });
  }
  async getLaborandItemSalesPriceGroup() {
    await this.paymentService.GetLaborandItemSalesPriceGroup().then((response) => {
      this.laborAndItemSalesPriceList = response.responseObject;
      if(this.laborAndItemSalesPriceList != null){
        let defaultValueLaborCode = response.responseObject.laborGroupPrice.filter((x:any)=>x.isDefault);
        let defaultItemSalesCode = response.responseObject.itemSalesPrice.filter((x:any)=>x.isDefault);
        if(defaultValueLaborCode.length > 0 && defaultItemSalesCode.length > 0){
          this.laborGroupPriceDefault = defaultValueLaborCode[0].code;
          this.itemSalesGroupPriceDefault = defaultItemSalesCode[0].code;
          this.customerForm.patchValue({
            laborPriceGroup : this.laborGroupPriceDefault,
            itemSalesPriceGroup : this.itemSalesGroupPriceDefault,
          })
        }
      }
    });
  }
  onAdvanceSearch() {
    this.isAdvanceSearch = true;
  }
  async onApplyAdvanceSearch() {
    this.isAdvanceSearch = false;
    this.spinner.show();
    if (this.advanceSearchRequest.birthDate == '' && this.advanceSearchRequest.customerName == '' && this.advanceSearchRequest.postCode == null && this.advanceSearchRequest.mobile == '') {
      this.spinner.hide();
      let lblCustomerDetailsAreNotFound = this.translate.instant("lblCustomerDetailsAreNotFound.");
      this.toaster.error(lblCustomerDetailsAreNotFound);
      return;
    }
    this.companyShow = null;
    this.advanceSearchRequest.birthDate = (this.advanceSearchRequest.birthDate != '') ? this.datepipe.transform(Utility.getDateStringToDate(this.advanceSearchRequest.birthDate), 'yyyy-MM-dd') : '';
    await this.service.getDFCustomerListByAdvanceSearch(this.advanceSearchRequest).then((resp) => {
      this.spinner.hide();
      this.customerList = this.service.DFCustomerDataMapper(resp.responseObject);
      this.totalCount = this.customerList.length > 0 ? this.customerList.length : 0;
      if (this.customerList?.length > 1) {
        this.OpenMultipleCustomerList(this.customerList, this.totalCount);
      }
      else if (this.customerList?.length == 1) {
        this.companyShow = this.customerList[0].customerTypeId == 2 ? true : false;
        this.PatchDataFound(this.customerList[0]);
        this.enableDisableControls();

      }
      else if (this.customerList?.length == 0) {
        let lblCustomerDetailsAreNotFound = this.translate.instant("lblCustomerDetailsAreNotFound.");
        this.toaster.error(lblCustomerDetailsAreNotFound);
      }
    }, _error => {
      this.spinner.hide()
    });
  }
  onResetAdvanceSearch() {
    this.advanceSearchRequest = {
      birthDate: '',
      customerName: '',
      postCode: null,
      mobile: ''
    }
  }
  onCloseAdvanceSearch() {
    this.advanceSearchRequest = {
      birthDate: '',
      customerName: '',
      postCode: null,
      mobile: ''
    }
    this.isAdvanceSearch = false;
  }
  async getAddressSalutationDropdown() {
    await this.service.GetAddressSalutationDropdown().then((response) => {
      this.addressSalutationList = response != null ? response.responseObject : [];
    });
  }

   getPostCodeDropdown() {
    let postCodes = this.secureStorage.getKeyData('postCodes');
    if (postCodes) {
      this.postCodeRawData = postCodes;
      this.BindPostData("");
      this.BindCityData("");
    } 
  }

  BindPostData(city) {
    if ( city?.trim()) {
      this.postCodeList = this.postCodeRawData.filter(f => f.city == city);
      if (this.postcodeName?.length === 0) {
        this.postcodeName = this.postCodeList[0]?.code;
      }
    } else {
      this.postCodeList = this.postCodeRawData;
    }
  }

  BindCityData(post) {
    if (post?.trim()) {
      let postdata = this.postCodeRawData.filter(f => f.code == post);
      this.cityList = postdata.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
      this.onCitySelected(this.cityList[0])
    } else {
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
    }
  }

  BindCountry(postCode) {
    let postdata = this.postCodeRawData.filter(f => f.code == postCode);
    let countryCode = postdata.map(item => item.countryCode).filter((value, index, self) => self.indexOf(value) === index);
    let selectedCountry = this.countryList.filter(f => f.code === countryCode[0])
    this.onselectCountry(selectedCountry[0]?.id);
  }

  async onPostCodeSelected(postCode: string) {
    this.postcodeName = postCode;
    if (postCode?.trim()) {
      this.BindCityData(postCode);
      this.BindCountry(postCode)
    } else {
      this.postCodeList = this.postCodeRawData;
      this.cityName = "";
      this.customerForm.patchValue({
        country: ''
      })
    }
  }

  async onCitySelected(city: any) {
    this.cityName = city;
    if (city?.trim()) {
      this.BindPostData(city);
      this.BindCountryBasedCity(city);
    } else {
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
      this.postcodeName = "";
      this.customerForm.patchValue({
        country: ''
      })
    }
  }
  BindCountryBasedCity(city) {
    let postdata = this.postCodeRawData.filter(f => f.city == city)
    let countryCode = postdata.map(item => item.countryCode).filter((value, index, self) => self.indexOf(value) === index);
    let selectedCountry = this.countryList.filter(f => f.code === countryCode[0])
    this.countryName = selectedCountry[0]?.countryName;
    this.countryId = selectedCountry[0]?.id;
  }
   async countryDropdownDetails(){
     await this.service.getCountryCodeAndMobileCodeDetails()
      .then(async (response) => {
        this.countryList = response?.responseObject?.result.filter(x => x.isDisplay);
        let local = this.cultureLocaleService.getLocale();
        if (this.customerId > 0 && this.countryId != undefined) {
          let obj = this.countryList?.filter(f => f.id == this.countryId);
          this.selectedCountryISOMobile= obj[0]?.code?.toLowerCase();
          this.selectedCountryISOLandline= obj[0]?.code?.toLowerCase();
          this.countryName = obj[0]?.countryName;
          this.userMobileCode = obj[0]?.mobileCode;
          this.userPhoneNumberCode = obj[0]?.mobileCode;
        } else {
          let obj = this.countryList?.filter(f => f.code == local.toUpperCase());
          this.selectedCountryISOMobile= local;
          this.selectedCountryISOLandline= local;
          this.countryName = obj[0]?.countryName;
          this.countryId = obj[0]?.id;
          this.userMobileCode = obj[0]?.mobileCode;
          this.userPhoneNumberCode = obj[0]?.mobileCode;
        }
        if (this.customerId > 0 && !this.isFromServiceAdvisor) {
          await this.getCustomerDetails(this.customerId);
          await this.GetCustomerPrivacyLog(this.customerId);
        }
        if (this.customerDetailsFromWidget !== null && this.isFromServiceAdvisor) {
          this.mapCustomerWidgetData();
        }
      });
  }

  mapCustomerWidgetData() {
    this.customerId = 0;
    this.customerForm.patchValue({
      custName: this.customerDetailsFromWidget.customerName,
      firstName: this.customerDetailsFromWidget.firstName,
      lastName: this.customerDetailsFromWidget.lastName,
      address1: this.customerDetailsFromWidget.address1,
      address2: this.customerDetailsFromWidget.address2,
      postcode: this.customerDetailsFromWidget.postCode,
      city: this.customerDetailsFromWidget.city,
      country: this.customerDetailsFromWidget.country,
      email: this.customerDetailsFromWidget.email,
      mobile: this.customerDetailsFromWidget.mobileNo,
    });
    if(this.customerDetailsFromWidget.userConsent){
      this.customerForm.patchValue({
        IsMarketingConsent:true,
        isRegularEmail:true,
        isEmail:true,
        isFax:true,
        isSms:true,
        isPhone:true
      })
    }
    this.customerDetailsFromWidget.cust_DialCountryCode = (this.customerDetailsFromWidget?.cust_DialCountryCode)?this.customerDetailsFromWidget?.cust_DialCountryCode:this.cultureLocaleService.getLocale();
    if(this.customerDetailsFromWidget.countryCode == null || this.customerDetailsFromWidget.countryCode == ''){
      this.customerDetailsFromWidget.countryCode = this.cultureLocaleService.getLocale()
    }
    this.selectedCountryISOMobile= this.customerDetailsFromWidget?.cust_DialCountryCode;
    this.userMobileCode = this.getMobileCodeByCountryCode(this.customerDetailsFromWidget?.cust_DialCountryCode);
    this.cdr.detectChanges();
  }

  get cpf() {
    return this.customerForm.controls;
  }
  onSearchFilter() {
    this.getDFCustomerList();
  }
  async getDFCustomerList() {
    this.spinner.show();
    if (this.search == '' || this.search == undefined || this.search == null) {
      this.spinner.hide();
      let lblCustomerDetailsAreNotFound = this.translate.instant("lblCustomerDetailsAreNotFound.");
      this.toaster.error(lblCustomerDetailsAreNotFound);
      return;
    }
    this.companyShow = null
    await this.service.getDFCustomerListByFullSearch(this.search).then((response) => {
      this.spinner.hide();
      this.customerList = this.service.DFCustomerDataMapper(response.responseObject);
      this.totalCount = this.customerList.length > 0 ? this.customerList.length : 0;
      if (this.customerList?.length > 1) {
        this.OpenMultipleCustomerList(this.customerList, this.totalCount);
      }
      else if (this.customerList?.length == 1) {
        this.companyShow = this.customerList[0].customerTypeId == 2 ? true : false;
        this.PatchDataFound(this.customerList[0]);
        this.enableDisableControls();
      }
      else if (this.customerList?.length == 0) {
        let lblCustomerDetailsAreNotFound = this.translate.instant("lblCustomerDetailsAreNotFound.");
        this.toaster.error(lblCustomerDetailsAreNotFound);
      }
    }, _error => {
      this.spinner.hide()
    });
  }
  OpenMultipleCustomerList(customerList: CustomerDetailsViewModel[], totalCount: number): void {
    const modalref = this.modalService.open(MultiCustomerListComponent, {
      size: 'lg',
      scrollable: true,
      windowClass: 'pop-wid1366 CustomCardPopup',
    });

    modalref.componentInstance.customerList = customerList;
    modalref.componentInstance.totalCount = totalCount;
    modalref.result.then(
      (response) => {
        if (response.success) {
          this.companyShow = response.customer.customerTypeId == 2 ? true : false
          this.PatchDataFound(response.customer);
          let element = <HTMLInputElement>document.getElementById("customCheck1");
          if (this.companyShow) {
            element.click();
          }
          element.setAttribute('disabled', '');
          this.enableDisableControls();
        }
      }
    );
  }
  getFormatedDateOfBirth(customer){
     if(this.companyShow){
      return "";
     }else{
      if(customer.registrationOrBirthDate != ""){
        return Utility.GetFormattedDate(customer.registrationOrBirthDate);
      }else{
        return "";
      }
     }
  }
  PatchDataFound(customer) {
    this.customerForm.patchValue({
      firstName: customer.firstName,
      lastName: customer.lastName,
      custName: customer.customerName,
      customergroup: this.empty(this.customerGroupDefault)? customer.customerGroup : this.customerGroupDefault,
      salutation: customer.salutation,
      personNumber: this.companyShow ? "" : customer.registrationOrPersonNumber,
      registrationNumber: this.companyShow ? customer.registrationOrPersonNumber : "",
      // dateOfBirth: this.companyShow ? "" : ((customer.registrationOrBirthDate != "") ? Utility.GetFormattedDate(customer.registrationOrBirthDate) : ""),
      dateOfBirth: this.getFormatedDateOfBirth(customer),
      // registrationDate: this.companyShow ? ((customer.registrationOrBirthDate != "") ? Utility.GetFormattedDate(customer.registrationOrBirthDate) : "") : "",
      registrationDate: this.getFormatedDateOfBirth(customer),
      address1: customer.addressLine1,
      address2: customer.addressLine2,
      postcode: customer.pincode,
      city: customer.city,
      country: customer.country,
      email: customer.email,
      email2: customer.email2,
      mobile: customer.mobileNo,
      landline: customer.phoneNumber,
      fax: customer.fax,
      isActive: true,
      isRegularEmail: customer.isRegularEmail,
      isEmail: customer.isEmail,
      isFax: customer.isFax,
      isSms: customer.isSms,
      isPhone: customer.isPhone,
      dataPrivacyStatus: customer.dataPrivacyStatus,
      contactID: customer.contactId,
      paymentMethodCode:this.paymentMethodDefault,
      paymentTermsCode:this.paymentTermDefault,
      reminderTermsCode:this.reminderTermDefault,
      laborPriceGroup : this.laborGroupPriceDefault,
      itemSalesPriceGroup : this.itemSalesGroupPriceDefault,
      gender: customer.gender == 'Female' ? '1' : '0'
    });

    this.selectDefaultCustomerGroup();
  }
  resetVariables() {
    this.companyShow = false;
    this.service.customerListRequest.customerTypeId = 0;
    this.service.customerListRequest.customerName = '';
    this.service.customerListRequest.customerNo = '';
    this.service.customerListRequest.customerGroup = null;
    this.service.customerListRequest.salutation = null;
    this.service.customerListRequest.postCode = null;
    this.service.customerListRequest.city = null;
    this.service.customerListRequest.email = '';
    this.service.customerListRequest.mobile = '';
    this.service.customerListRequest.licensePlateNo = '';
    this.service.customerListRequest.sourceOfCreation = '';
    this.search = null;
  }
  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  telInputObject() {
      if (this.userMobileCode) {
        this.userMobileCode = this.userMobileCode.replace('+', '');
        let countryCode = this.getCountryCodeByDialCode(this.userMobileCode);
        this.selectedCountryISOMobile= countryCode ? countryCode : this.cultureLocaleService.getLocale();
      }
      else
      {
        this.selectedCountryISOMobile= this.cultureLocaleService.getLocale();
      }
  }

  telInputObjectLandline() {
      if (this.userPhoneNumberCode) {
        this.userPhoneNumberCode = this.userPhoneNumberCode.replace('+', '');
        let countryCode = this.getCountryCodeByDialCode(this.userPhoneNumberCode);
        this.selectedCountryISOLandline= (countryCode ? countryCode : this.cultureLocaleService.getLocale());
      }
      else
        this.selectedCountryISOLandline= (this.cultureLocaleService.getLocale());
  }

  getCountryCodeByDialCode(dialCode: any) {
    const country = this.countryDialCodes.find(c => c.dialCode === dialCode);
    return country ? country.countryCode : null;
  }

  getMobileCodeByCountryCode(countryCode:string){
    const country = this.countryDialCodes.find(c => c.countryCode === countryCode.toLowerCase());
    return country ? country.dialCode : null;
  }
  
  onCountryChange(obj3) {
      this.userMobileCode = obj3.dialCode;
    this.telInputObject();
  }

  onCountryChangeLandline(obj3) {
    if (this.isInitialLoadLandline) {
    this.telInputObjectLandline();
    if(obj3.dialCode){
      this.userPhoneNumberCode = obj3.dialCode;
    }
    this.isInitialLoadLandline = false;
    } else {
      this.userPhoneNumberCode = obj3.dialCode;
    }
  }

  onselectCountry(event): void {
    this.countryId = event ?? 0;

    if (this.countryId > 0) {
      let obj = this.countryList?.filter(f => f.id == this.countryId);
      this.selectedCountryISOMobile= obj[0]?.code?.toLowerCase();
      this.selectedCountryISOLandline= obj[0]?.code?.toLowerCase();
      this.countryName = obj[0]?.countryName;
      this.userMobileCode = obj[0]?.mobileCode;
      this.userPhoneNumberCode = obj[0]?.mobileCode;
    } else {
      let local = this.cultureLocaleService.getLocale();
      let obj = this.countryList?.filter(f => f.code == local.toUpperCase());
      this.selectedCountryISOMobile= local;
      this.selectedCountryISOLandline= local;
      this.countryName = obj[0]?.countryName;
      this.countryId = obj[0]?.id;
      this.userMobileCode = obj[0]?.mobileCode;
      this.userPhoneNumberCode = obj[0]?.mobileCode;
      this.cityName = "";
      this.postcodeName = "";
    }
  }

  changeAccount(event: Event) {
    this.accountShow = (event.target as HTMLInputElement).checked;
  }

  changeCustomerType(event: Event) {
    this.companyShow = (event.target as HTMLInputElement).checked;
    this.enableDisableControls();
    this.selectDefaultCustomerGroup();
  }
  enableDisableControls() {
    if (this.companyShow) {
      this.customerForm.controls.personNumber.reset();
      this.customerForm.controls.dateOfBirth.reset();

      this.customerForm.controls.lastName.disable();
      this.customerForm.controls.firstName.disable();
      this.customerForm.controls.personNumber.disable();
      this.customerForm.controls.dateOfBirth.disable();

      this.customerForm.controls.custName.enable();
      this.customerForm.controls.registrationNumber.enable();
      this.customerForm.controls.registrationDate.enable();
    } else {
      this.customerForm.controls.registrationNumber.reset();
      this.customerForm.controls.registrationDate.reset();

      this.customerForm.controls.custName.disable();
      this.customerForm.controls.registrationNumber.disable();
      this.customerForm.controls.registrationDate.disable();

      this.customerForm.controls.lastName.enable();
      this.customerForm.controls.firstName.enable();
      this.customerForm.controls.personNumber.enable();
      this.customerForm.controls.dateOfBirth.enable();
    }
    
  }

  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }

  changeVatApplyOnDemand(event: Event){
    this.isVatApplyOnDemandDefault = (event.target as HTMLInputElement).checked;
  }
  async SaveButtonEvent(isSaveAndClose){
    if(this._clientName === 'mg' && this.isCrmNewVehicle){
      await this.crmAddEditCustomer(isSaveAndClose);
    }else{
      await this.AddEditCustomer(isSaveAndClose);
    }
  }

  async crmAddEditCustomer(isSaveAndClose) {
    let errorMessage = this.translate.instant("lblErrorMessage");
    let WarningMessage = this.translate.instant("lblErrorWarningForValue")

    let successMessage = "";
    if (this.service.crmVehicleObj?.id === 0) {
      successMessage = this.translate.instant("lblVehicleAddedSuccessfully");
    } else {
      successMessage = this.translate.instant("lblVehicleUpdatedSuccessfully");
    }

    this.spinner.show();
    await this.vehicleservice.crmAddEditVehicle(this.service.crmVehicleObj).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        this.responseResult = res.responseObject;
        this.service.vehicleId =this.responseResult.retValue;
        if (this.responseResult.isSuccess) {
          this.toaster.success(successMessage);
          this.AddEditCustomer(isSaveAndClose);
        } else {
          if (this.responseResult.retValue == "-8000") {
            successMessage = this.translate.instant("lblAlreadyVehicleMapped");
          } else {
            successMessage = this.responseResult.resultMessage;
          }
          this.toaster.warning(successMessage);
        }
      }
      else if (res.responseCode === Constant.InternalError) {
        let errormsg = this.translate.instant("lblInternalError");
        this.toaster.error(errormsg);
      }
      else if (res.responseCode === Constant.ResponseCode) {
        let errormsg = this.translate.instant("lblAlreadyAdded");
        this.toaster.warning(errormsg);
      }
      this.spinner.hide();

    }, error => {
      this.spinner.hide();
      if (error.status === Constant.BadRequest) {
        this.toaster.warning(WarningMessage);
      }
      else {
        this.toaster.error(errorMessage);
      }
    });
  }

  async AddEditCustomer(isSaveAndClose) {
    if (!this.customerForm.valid) {
      this.isFormValid = true;
      return;
    }
    this.isFormValid = false;
    let customerInfo =
    {
      customerId: this.customerId,
      contactUniqueId: this.contactUniqueId,
      firstName: "",
      lastName: "",
      custName: "",
      accountCompanyName: this.empty(this.accountCompanyId) ? "" : this.accountCompanyId,
      address1: this.empty(this.customerForm.get('address1').value) ? "" : this.customerForm.get('address1').value,
      address2: this.empty(this.customerForm.get('address2').value) ? "" : this.customerForm.get('address2').value,
      zipcode: this.empty(this.customerForm.get('postcode').value) ? "" : this.customerForm.get('postcode').value,
      city: this.empty(this.customerForm.get('city').value) ? "" : this.customerForm.get('city').value,
      state: "",
      countryId: this.countryId,
      mobileNo: this.customerForm.get('mobile').value?.number ? this.customerForm.get('mobile').value.number.toString().replace(/\s+/g, '') : this.customerForm.get('mobile').value,
      mobileCode: this.empty(this.userMobileCode) ? "" : this.userMobileCode.replace("+", ""),
      email: this.customerForm.get('email').value,
      latitude: 0,
      longitude: 0,
      customerNo: this.empty(this.customerForm.get('customerNo').value) ? "" : this.customerForm.get('customerNo').value,
      langaugeCode: "",
      blocked: this.customerForm.get('isActive').value ? 0 : 1,
      phoneNumberCode: this.empty(this.userPhoneNumberCode) ? "" : this.userPhoneNumberCode.replace("+", ""),
      phoneNumber: this.customerForm.get('landline').value?.number ? this.customerForm.get('landline').value.number.toString().replace(/\s+/g, '') : this.customerForm.get('landline').value,
      customerTypeId: 0,
      registrationOrPersonNumber: "",
      registrationOrBirthDate: null,
      customerGroup: this.customerForm.get('customergroup').value,
      salutation: this.empty(this.customerForm.get('salutation').value) ? "" : this.customerForm.get('salutation').value,
      email2: this.empty(this.customerForm.get('email2').value) ? "" : this.customerForm.get('email2').value,
      fax: this.empty(this.customerForm.get('fax').value) ? "" : this.customerForm.get('fax').value,
      ownerTypeId: 0,
      sourceTypeId: 1,
      isActive: this.customerForm.get('isActive').value,
      isRegularEmail: this.customerForm.get('isRegularEmail').value,
      isEmail: this.customerForm.get('isEmail').value,
      isFax: this.customerForm.get('isFax').value,
      isSms: this.customerForm.get('isSms').value,
      isPhone: this.customerForm.get('isPhone').value,
      isMarketingConsent: this.customerForm.get('IsMarketingConsent').value,
      customerDisagreement:this.customerForm.get('customerDisagreement').value,
      remark:this.customerForm.get('remark').value,
      isMinBilUser:this.customerForm.get('isMinBilUser').value,
      navisionId:this.customerForm.get('navisionId').value,
      cbid:this.customerForm.get('cbid').value,
      dataPrivacyStatus: 0,
      integrationWithDMS: false,
      moduleId: ModuleNames.Customer,
      countryCode: this.countryList?.find(f => f.id == this.countryId).code,
      generateCustomerNoPlannerSide: false,
      realtimeDmsSyncCustomer: true,
      isAccountHolderCompany: this.empty(this.customerForm.get('isAccountHolderCompany').value) ? false : this.customerForm.get('isAccountHolderCompany').value,
      isAddAccount: false,
      contactId: this.empty(this.customerForm.get('contactID').value) ? "" : this.customerForm.get('contactID').value,
      paymentMethodCode: this.empty(this.customerForm.get('paymentMethodCode').value) ? "" : this.customerForm.get('paymentMethodCode').value,
      paymentTermsCode: this.empty(this.customerForm.get('paymentTermsCode').value) ? "" : this.customerForm.get('paymentTermsCode').value,
      reminderTermsCode: this.empty(this.customerForm.get('reminderTermsCode').value) ? "" : this.customerForm.get('reminderTermsCode').value,
      laborPriceGroup: this.empty(this.customerForm.get('laborPriceGroup').value) ? "" : this.customerForm.get('laborPriceGroup').value,
      itemSalesPriceGroup: this.empty(this.customerForm.get('itemSalesPriceGroup').value) ? "" : this.customerForm.get('itemSalesPriceGroup').value,
      preferredDealerId: this.empty(this.customerForm.get('dealerId').value) ? "" : this.customerForm.get('dealerId').value,
      isVatApplyOnDemand : this.isVatApplyOnDemandDefault
    }
    this.service.customerMobileNo = this.customerForm.get('mobile').value?.number ? this.customerForm.get('mobile').value.number.toString().replace(/\s+/g, '') : this.customerForm.get('mobile').value;
    if (this.features && this.features.length > 0) {
      let feature = this.features.find(x => x.featureCode === FeatureCode.DMS)?.isActive
      customerInfo.integrationWithDMS = feature;
      let featureGenerate = this.features.find(x => x.featureCode === FeatureCode.GCuNoPlannerSide)?.isActive
      customerInfo.generateCustomerNoPlannerSide = featureGenerate;
      let realTimeSync = this.features.find(x => x.featureCode === FeatureCode.RTDSC)?.isActive
      customerInfo.realtimeDmsSyncCustomer = realTimeSync;
    }

    if (customerInfo.isRegularEmail || customerInfo.isEmail || customerInfo.isSms || customerInfo.isPhone) {
      customerInfo.dataPrivacyStatus = 1;
    }

    const temp = new Date();
    let element = <HTMLInputElement>document.getElementById("customCheck1");
    this.companyShow = element != null? element.checked: this.companyShow;
    if (this.companyShow) {
      customerInfo.customerTypeId = 2;
      customerInfo.custName = this.empty(this.customerForm.get('custName').value) ? "" : this.customerForm.get('custName').value;
      customerInfo.firstName = customerInfo.custName;
      customerInfo.registrationOrPersonNumber = this.customerForm.get('registrationNumber').value;
      if (!this.empty(this.customerForm.get('registrationDate').value)) {
        let registerdate = new Date(Utility.getDateStringToDate(this.customerForm.get('registrationDate').value).getTime() - (temp.getTimezoneOffset() * 60000));
        customerInfo.registrationOrBirthDate = registerdate;
      } else {
        customerInfo.registrationOrBirthDate = "";
      }
    } else {
      customerInfo.customerTypeId =(this.customerForm.get('gender').value) == '1' ?  1 : 0
      customerInfo.firstName = this.empty(this.customerForm.get('firstName').value) ? "" : this.customerForm.get('firstName').value;
      customerInfo.lastName = this.empty(this.customerForm.get('lastName').value) ? "" : this.customerForm.get('lastName').value;
      customerInfo.custName = customerInfo.firstName + " " + customerInfo.lastName;
      customerInfo.registrationOrPersonNumber = this.customerForm.get('personNumber').value == null ? "" : this.customerForm.get('personNumber').value;
      if (!this.empty(this.customerForm.get('dateOfBirth').value)) {
        let registerdate = new Date(Utility.getDateStringToDate(this.customerForm.get('dateOfBirth').value).getTime() - (temp.getTimezoneOffset() * 60000));
        customerInfo.registrationOrBirthDate = registerdate;
      } else {
        customerInfo.registrationOrBirthDate = "";
      }
    }

    if (this.customerId == 0) {
      let checkDuplicateCustomerModel = {
        Dial_Code: customerInfo.mobileCode,
        mobileNo: customerInfo.mobileNo,
        fullName: customerInfo.custName,
        email: customerInfo.email
      }
      this.spinner.show();
      let CustomerMobilerCheck = await this.service.CheckCustomerDuplication(checkDuplicateCustomerModel);
      if (CustomerMobilerCheck != null) {
        this.duplicateCustomerList = CustomerMobilerCheck;
        this.duplicateCustomerList = this.duplicateCustomerList.filter(x=>x.customerNumber != customerInfo.customerNo);
        if(this.duplicateCustomerList.length > 0){
          this.spinner.hide();
          this.modalService.open(this.customerDuplication, { size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
            //Saving New customer details
          }, (reason) => {
            if(reason){
              this.SaveUpdateCustomer(customerInfo,isSaveAndClose);
            }
          });
        }
        else{
          this.spinner.show();
          this.SaveUpdateCustomer(customerInfo,isSaveAndClose);
        }
      }
      else {
        this.SaveUpdateCustomer(customerInfo,isSaveAndClose);
      }
    } else {
       let checkDuplicateCustomerModel = {
        Dial_Code: customerInfo.mobileCode,
        mobileNo: customerInfo.mobileNo,
        fullName: customerInfo.custName,
        email: customerInfo.email
      }
      this.spinner.show();
      let CustomerMobilerCheck = await this.service.CheckCustomerDuplication(checkDuplicateCustomerModel);
      if (CustomerMobilerCheck != null) {
        this.duplicateCustomerList = CustomerMobilerCheck;
        this.duplicateCustomerList = this.duplicateCustomerList.filter(x=>x.customerNumber != customerInfo.customerNo);
        if (this.duplicateCustomerList.length > 0) {
          this.spinner.hide();
          this.modalService.open(this.customerDuplication, { size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
          }, (reason) => {
            if (reason) {
              this.SaveUpdateCustomer(customerInfo, isSaveAndClose);
            }
            else {
              this.customerForm.patchValue({
                firstName: this.customerDetail.firstName,
                lastName: this.customerDetail.lastName,
                email: this.customerDetail.email,
                mobile: this.customerDetail.mobileNo,
              })
              this.userMobileCode = this.customerDetail.mobileCode;
              this.telInputObject();
              this.cdr.detectChanges();
            }
          }); 
        }
        else{
         this.spinner.hide();
         this.SaveUpdateCustomer(customerInfo, isSaveAndClose);
        }
      }
    }
  }

  showVehileAndOtherDetailsTabsFn() {
    this.saveVehicleDetails = true;
    this.AddEditCustomer(true);

  }

  showVehileAndOtherDetailsTabsFn1() {
    this.showVehileAndOtherDetailsTabs.emit();
  }

  async SaveUpdateCustomer(customerInfo: CustomerModel,isSaveAndClose:boolean) {
    let errorMessage = this.translate.instant("lblErrorMessage");
    let WarningMessage = this.translate.instant("lblErrorWarningForValue")

    let successMessage = "";
    if (this.customerId === 0) {
      successMessage = this.translate.instant("lblCustomerAddedSuccessfully");
    } else {
      successMessage = this.translate.instant("lblCustomerUpdatedSuccessfully");
    }
    this.spinner.show();
    await this.service.addEditCustomer(customerInfo).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        this.responseResult = res.responseObject;
        if (this.responseResult.isSuccess) {

          if (this.saveVehicleDetails) {
            this.vehicleservice.customerId = this.responseResult.retValue;
            this.vehicleservice.customerNo = this.responseResult.customerNo;
            this.vehicleservice.customerName = customerInfo.custName;
            this.showVehileAndOtherDetailsTabs.emit();
          } else {
            this.service.customerId = this.responseResult.retValue;
            this.service.CustomerNumber = this.responseResult.customerNo;
            //edit mode and click on save&close
            if(this.customerId > 0){
              if(isSaveAndClose)
              {
                this.activeModal.close({ success: true });
              }
            }else{
                if(this.isFromServiceAdvisor || this.fromVehicleScreen){
                  this.activeModal.close({ success: true });
                }else{
                  this.activeModal.close({ success: true });
                  this.ConvertFormToEditScreen(this.responseResult.retValue, this.responseResult.customerNo);
                }
            }
          }
          this.GetCustomerPrivacyLog(this.customerId);
        } else {
          successMessage = this.responseResult.resultMessage;
        }


        this.toaster.success(successMessage);
      }
      else if (res.responseCode === Constant.InternalError) {
        let errormsg = this.translate.instant("lblInternalError");
        this.toaster.error(errormsg);
      }
      else if (res.responseCode === Constant.ResponseCode) {
        let errormsg = this.translate.instant("lblAlreadyAdded");
        this.toaster.warning(errormsg);
      }
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
      if (error.status === Constant.BadRequest) {
        this.toaster.warning(WarningMessage);
      }
      else {
        this.toaster.error(errorMessage);
      }
    });
  }

  ConvertFormToEditScreen(id : number,no:string){
    this.service.customerId = id;
    if (id > 0) {
      let firstName = this.empty(this.customerForm.get('firstName').value) ? "" : this.customerForm.get('firstName').value;
      let lastName = this.empty(this.customerForm.get('lastName').value) ? "" : this.customerForm.get('lastName').value;
      let custName = firstName + " " + lastName;

      this.service.customerNo = no;
      this.service.customerName = custName;
      this.service.customerDetail = null;
      this.service.firstName = firstName;
      this.service.lastName = lastName;
    } else {
      this.service.customerNo = "";
      this.service.customerName = "";
      this.service.customerDetail = null;
      this.service.firstName="";
      this.service.lastName=""
    }
    const modalref = this.modalService.open(ViewCustomerComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.componentInstance.isFromServiceAdvisor = false;
    modalref.componentInstance.fromVehicleScreen = this.fromVehicleScreen;
    modalref.componentInstance.isAddNewVehile = this.service.IsCustomerAddFromVehicle;
    modalref.componentInstance.VehicleNumber = this.service.VehicleNumber;
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    }, _error => {
      // This is intentional
    });
  }

  ngOnDestroy(): void {
    this.isFormValid = false;
  }

  async getCustomerDetails(id) {
    await this.service.getCustomerById(id).then(async (response) => {
      this.customerDetail = response.responseObject as CustomerDetailsViewModel;
      this.service.customerDetail = this.customerDetail;
      this.companyShow = this.customerDetail.customerTypeId == 2 ? true : false;
      this.isVatApplyOnDemandDefault = this.customerDetail.isVatApplyOnDemand;
      this.countryId = this.customerDetail.countryId;
      this.contactUniqueId = this.customerDetail.contactUniqueId;
      this.customerForm.patchValue({
        firstName: this.customerDetail.firstName,
        lastName: this.customerDetail.lastName,
        custName: this.customerDetail.customerName,
        customergroup: this.customerDetail.customerGroup,
        customerNo: this.customerDetail.customerNo,
        salutation: this.customerDetail.salutation,
        personNumber: this.companyShow ? "" : this.customerDetail.registrationOrPersonNumber,
        registrationNumber: this.companyShow ? this.customerDetail.registrationOrPersonNumber : "",
        dateOfBirth: this.companyShow ? "" : this.customerDetail.registrationOrBirthDate,
        registrationDate: this.companyShow ? this.customerDetail.registrationOrBirthDate : "",
        accountCompanyName:this.customerDetail.customerName,
        address1: this.customerDetail.addressLine1,
        address2: this.customerDetail.addressLine2,
        postcode: this.customerDetail.pincode,
        city: this.customerDetail.city,
        country: this.customerDetail.country,
        email: this.customerDetail.email,
        email2: this.customerDetail.email2,
        mobile: this.customerDetail.mobileNo,
        landline: this.customerDetail.phoneNumber,
        fax: this.customerDetail.fax,
        isActive: this.customerDetail.isActive,
        isRegularEmail: this.customerDetail.isRegularEmail,
        isEmail: this.customerDetail.isEmail,
        isFax: this.customerDetail.isFax,
        isSms: this.customerDetail.isSms,
        isPhone: this.customerDetail.isPhone,
        IsMarketingConsent:this.customerDetail.isMarketingConsent,
        customerDisagreement:this.customerDetail.customerDisagreement,
        dataPrivacyStatus: this.customerDetail.dataPrivacyStatus,
        isAccountHolderCompany: this.customerDetail.isAccount,
        paymentMethodCode: this.customerDetail.paymentMethodCode,
        paymentTermsCode: this.customerDetail.paymentTermsCode,
        reminderTermsCode: this.customerDetail.reminderTermsCode,
        laborPriceGroup  : this.customerDetail.dmsLaborPriceGroup,
        itemSalesPriceGroup : this.customerDetail.dmsItemSalesPriceGroup,
        gender:this.customerDetail.customerTypeId == 1 ? '1' : '0',
        dealerId: this.customerDetail.preferredDealerId,
        remark: this.customerDetail.remark,
        navisionId: this.customerDetail.navisionId,
        isMinBilUser: this.customerDetail.isMinBilUser,
        cbid: this.customerDetail.cbid
      });
      if (!this.empty(this.customerDetail.mobileNo))
      {
        this.existingMobileNo = this.customerDetail.mobileNo;
      }
      if(!this.empty(this.customerDetail.accountId)){
        await this.getAccountName(this.customerDetail.accountId);
        this.accountCompanyId=this.customerDetail.accountId;
      }
      if (this.countryList != undefined) {
        let obj = this.countryList?.filter(f => f.id == this.countryId);
        this.countryName = obj[0]?.countryName;
      }

      if (this.customerDetail.mobileCode !== null && this.customerDetail.mobileCode !== '0') {
        this.userMobileCode = this.customerDetail.mobileCode;
      }
      this.telInputObject();
      if (this.customerDetail.phoneNumberCode !== null && this.customerDetail.phoneNumberCode !== '0') {
        this.userPhoneNumberCode = this.customerDetail.phoneNumberCode;
      }
      this.telInputObjectLandline();

      this.registrationDate = this.companyShow ? this.customerDetail.registrationOrBirthDate : "";
        this.dateOfBirth = this.companyShow ? "" : this.customerDetail.registrationOrBirthDate;
        this.service.customerNo = this.customerDetail.customerNo;
      this.service.customerName = this.customerDetail.customerName;

      this.enableDisableControls();
      if (this.customerId > 0) {
        //this is intentional
      }
    });
  }

  async GetCustomerPrivacyLog(id) {
    await this.service.GetCustomerPrivacyLogById(id).then((response) => {
      if(!(response.responseObject && response.responseObject.errorCount===1))
      {
        this.customerLogDetails=response.responseObject;
      }
    });
  }


  OnClose() {
    this.isFormValid = false;
    this.activeModal.close({ success: true });
  }
  
  changeIsAccountHolderCompany(event: any){
    this.isShowAccountCompanyName = !((event.target as HTMLInputElement).checked);
  }
  onMobileChange(){
    if(this.customerForm.get('mobile').value){
      let len= this.customerForm.get('mobile').value.number.toString().replace(/\s+/g, '').length;
      if(len<8 || len>11){
        this.customerForm.get('mobile').setValidators([Validators.required, Validators.pattern(/^\d{8,11}$/)]);
        this.customerForm.get('mobile').updateValueAndValidity();
      } else {
        this.customerForm.get('mobile').setValidators([Validators.required]);
        this.customerForm.get('mobile').updateValueAndValidity();
      }
    } 
  }
  onLandlineChange(){
    if(this.customerForm.get('landline').value){
      let len= this.customerForm.get('landline').value.number.toString().replace(/\s+/g, '').length;
      if(len<8 || len>10){
        this.customerForm.get('landline').setValidators([Validators.pattern(/^\d{8,10}$/)]);
        this.customerForm.get('landline').updateValueAndValidity();
      } else {
        this.customerForm.get('landline').setValidators([]);
        this.customerForm.get('landline').updateValueAndValidity();
      }
    }
  }
}
